export default __webpack_public_path__ + "static/media/detail_two.93236857.png";